import {
  Button,
  Checkdiv,
  Divider,
  Row,
  Col,
  TimePicker,
  Menu,
  Dropdown,
  Typography,
  Tooltip,
  Radio,
  Spin,
  Checkbox,
} from 'antd';
import {
  CloseOutlined,
  LoadingOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import { MdContentCopy } from 'react-icons/md';
import {
  getRestaurantDetails,
  updateRestaurantOperationTimeAction,
} from '../../Actions/RestaurantAction';

const { Text } = Typography;

const UpdateOperationTime = ({ data, orgTimeZone, orgDetailsId }) => {
  const dispatch = useDispatch();

  const { isUpdateRestaurantLoading } = useSelector((state) => {
    return state.restaurant;
  });

  const weekKeys = Object.keys(data);

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <Row gutter={[0, 16]}>
          {weekKeys.map((day, i) => (
            <Col span={24} key={i}>
              <EditTimeCard
                data={data[day]}
                day={day}
                orgTimeZone={orgTimeZone}
                weekKeys={weekKeys}
                completeWeekObj={data}
                timeSlots={data[day]?.hours || []}
                orgDetailsId={orgDetailsId}
                loading={isUpdateRestaurantLoading}
              />
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

const EditTimeCard = ({
  data,
  day,
  orgTimeZone,
  weekKeys,
  completeWeekObj,
  timeSlots,
  orgDetailsId,
  loading,
}) => {
  const dispatch = useDispatch();

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuType, setMenuType] = useState(null);
  const [copytimeTo, setCopyTimeTo] = useState([]);
  const [localSlots, setLocalSlots] = useState(timeSlots);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const isOpen = data?.is_open;
  const openForAllDay = data?.is_open_all_day;

  const updateTime = (newTime, timeType, hourslot) => {
    const formattedTime = newTime
      .tz(orgTimeZone)
      .format('YYYY-MM-DDTHH:mm:ssZ');

    const updatedSlots = localSlots.map((slot, index) =>
      index === hourslot ? { ...slot, [timeType]: formattedTime } : slot
    );
    setLocalSlots(updatedSlots);

    const updatedTime = {
      id: orgDetailsId,
      operation_timing: {
        ...completeWeekObj,
        [day]: {
          ...data,
          hours: updatedSlots,
        },
      },
    };

    dispatch(
      updateRestaurantOperationTimeAction(
        updatedTime,
        () => dispatch(getRestaurantDetails()),
        () => {}
      )
    );
  };

  const removeTimeSlot = (index) => {
    const updatedSlots = localSlots.filter((_, i) => i !== index);
    setLocalSlots(updatedSlots);

    const updatedTime = {
      id: orgDetailsId,
      operation_timing: {
        ...completeWeekObj,
        [day]: {
          ...data,
          hours: updatedSlots,
        },
      },
    };

    dispatch(
      updateRestaurantOperationTimeAction(
        updatedTime,
        () => dispatch(getRestaurantDetails()),
        () => {}
      )
    );
  };

  useEffect(() => {
    setLocalSlots(timeSlots);
  }, [timeSlots]);

  const handleIconClick = (event, type) => {
    setMenuAnchor(event.currentTarget);
    setMenuType(type);
  };

  return (
    <div className='editTimeCard'>
      <div className='editCartHeaderContainer'>
        <Typography className='editCardDaytext'>{day}</Typography>
        <div className='iconsContainer'>
          <Dropdown
            open={dropdownOpen}
            onOpenChange={setDropdownOpen}
            overlay={
              <MenuComponent
                data={data}
                day={day}
                component={menuType}
                weekKeys={weekKeys}
                copytimeTo={copytimeTo}
                setCopyTimeTo={setCopyTimeTo}
                timeSlots={localSlots}
                completeWeekObj={completeWeekObj}
                orgDetailsId={orgDetailsId}
                dropdownOpen={dropdownOpen}
                setDropdownOpen={setDropdownOpen}
                loading={loading}
              />
            }
            style={{ backgroundColor: '#f6f6f6' }}
            trigger={['click']}
          >
            <Tooltip title={'Copy time to'}>
              <MdContentCopy
                style={{ cursor: 'pointer' }}
                fontSize={18}
                onClick={(e) => handleIconClick(e, 'copy')}
              />
            </Tooltip>
          </Dropdown>
          <Dropdown
            overlay={
              <MenuComponent
                data={data}
                day={day}
                component={menuType}
                weekKeys={weekKeys}
                copytimeTo={copytimeTo}
                setCopyTimeTo={setCopyTimeTo}
                timeSlots={localSlots}
                completeWeekObj={completeWeekObj}
                orgDetailsId={orgDetailsId}
                loading={loading}
              />
            }
            trigger={['click']}
          >
            <MoreOutlined
              style={{ fontSize: 18 }}
              onClick={(e) => handleIconClick(e, 'more')}
            />
          </Dropdown>
        </div>
      </div>
      <Divider style={{ margin: '16px 0px' }} />
      <div className='editTimeContent'>
        {isOpen ? (
          openForAllDay ? (
            <Typography className='closeAllDay'>Open all day</Typography>
          ) : (
            <div className='timePickerFieldContainer'>
              {localSlots?.map((hour, i) => {
                const startTime = hour?.start_time
                  ? moment(hour.start_time)
                  : null;
                const endTime = hour?.end_time ? moment(hour.end_time) : null;

                return (
                  <div key={i}>
                    <div>
                      <div className='timePickerField'>
                        <div>
                          <TimePicker
                            size='large'
                            value={startTime}
                            format='HH:mm'
                            onChange={(value) =>
                              updateTime(value, 'start_time', i)
                            }
                            style={{
                              width: i !== 0 ? '186px' : '200px',
                              borderRadius: '4px',
                            }}
                            className='timePicker'
                          />
                        </div>
                        <div>-</div>
                        <div>
                          <TimePicker
                            size='large'
                            value={endTime}
                            format='HH:mm'
                            onChange={(value) =>
                              updateTime(value, 'end_time', i)
                            }
                            style={{
                              width: i !== 0 ? '186px' : '200px',
                              borderRadius: '4px',
                            }}
                            className='timePicker'
                          />
                        </div>
                        {i !== 0 && (
                          <div className='centerItem'>
                            <CloseOutlined
                              className='removeIcon'
                              onClick={() => removeTimeSlot(i)}
                              style={{ fontSize: 18, cursor: 'pointer' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {i !== localSlots?.length - 1 && (
                      <Divider
                        style={{ marginTop: 8, marginBottom: 8, width: '100%' }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          )
        ) : (
          <Typography className='closeAllDay'>Closed all day</Typography>
        )}
      </div>
    </div>
  );
};

const MenuComponent = ({
  component,
  weekKeys,
  setCopyTimeTo,
  copytimeTo,
  timeSlots,
  completeWeekObj,
  orgDetailsId,
  data,
  day,
  loading,
  dropdownOpen,
  setDropdownOpen,
}) => {
  const dispatch = useDispatch();
  const allSelected = copytimeTo.length === weekKeys.length;

  const [selectedOption, setSelectedOption] = useState(
    data.is_open
      ? data.is_open_all_day
        ? 'openAllDay'
        : 'openPartDay'
      : 'closedAllDay'
  );

  const handleRadioChange = (type) => {
    setSelectedOption(type);
    timeSlotUpdate(type);
  };

  const handleCheckboxChange = (day, type) => {
    if (type === 'All') {
      setCopyTimeTo(weekKeys);
    } else if (type === 'remove') {
      setCopyTimeTo([day]);
    } else {
      setCopyTimeTo((prevSelected) => {
        const updated = prevSelected.includes(day)
          ? prevSelected.filter((d) => d !== day)
          : [...prevSelected, day];
        return updated;
      });
    }
  };

  const timeSlotUpdate = (type) => {
    if (type === 'addTimeSlot') {
      const newTimeSlots = [...timeSlots];
      const newTimeSlot = {
        start_time: '',
        end_time: '',
      };
      newTimeSlots.push(newTimeSlot);

      const updatedTime = {
        id: orgDetailsId,
        operation_timing: {
          ...completeWeekObj,
          [day]: {
            ...data,
            hours: newTimeSlots,
          },
        },
      };
      dispatch(updateRestaurantOperationTimeAction(updatedTime));
    } else if (type === 'openAllDay') {
      const updatedTime = {
        id: orgDetailsId,
        operation_timing: {
          ...completeWeekObj,
          [day]: {
            ...data,
            is_open: true,
            is_open_all_day: true,
            hours: data.hours,
          },
        },
      };
      dispatch(updateRestaurantOperationTimeAction(updatedTime));
    } else if (type === 'openPartDay') {
      const updatedTime = {
        id: orgDetailsId,
        operation_timing: {
          ...completeWeekObj,
          [day]: {
            ...data,
            is_open: true,
            is_open_all_day: false,
            hours: data.hours,
          },
        },
      };

      dispatch(updateRestaurantOperationTimeAction(updatedTime));
    } else if (type === 'closedAllDay') {
      const updatedTime = {
        id: orgDetailsId,
        operation_timing: {
          ...completeWeekObj,
          [day]: {
            ...data,
            is_open: false,
            is_open_all_day: false,
            hours: data.hours,
          },
        },
      };

      dispatch(updateRestaurantOperationTimeAction(updatedTime));
    }
  };

  const handleApplyAllChange = () => {
    if (!copytimeTo.length) return;

    const updatedOperationTiming = { ...completeWeekObj };

    copytimeTo.forEach((targetDay) => {
      updatedOperationTiming[targetDay] = {
        ...updatedOperationTiming[targetDay],
        is_open: data.is_open,
        is_open_all_day: data.is_open_all_day,
        hours: [...timeSlots],
      };
    });

    const updatedTime = {
      id: orgDetailsId,
      operation_timing: updatedOperationTiming,
    };

    dispatch(updateRestaurantOperationTimeAction(updatedTime, successUpdate));
  };

  const successUpdate = () => {
    setDropdownOpen(false);
  };

  useEffect(() => {
    setCopyTimeTo([day]);
  }, []);

  return component === 'copy' ? (
    <Menu style={{ width: 240 }}>
      <Menu.Item key='copytime-header' disabled style={{ cursor: 'default' }}>
        <div style={{ margin: '16px 12px' }}>
          <Typography className='timing'>Copy time to</Typography>
        </div>
      </Menu.Item>

      <Menu.Divider />

      <Menu.Item key='select-all' disabled style={{ cursor: 'default' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '0 12px',
          }}
        >
          <Typography className='timing'>Select all</Typography>
          <Checkbox
            checked={allSelected}
            onClick={(e) => e.stopPropagation()}
            onChange={() =>
              handleCheckboxChange(
                allSelected ? day : weekKeys,
                allSelected ? 'remove' : 'All'
              )
            }
          />
        </div>
      </Menu.Item>

      {weekKeys?.map((dayName, i) => (
        <Menu.Item
          key={dayName}
          disabled={dayName === day}
          style={{ cursor: dayName === day ? 'not-allowed' : 'pointer' }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              margin: '0 12px',
            }}
          >
            <Typography className='timing' style={{ marginRight: 90 }}>
              {dayName}
            </Typography>
            <Checkbox
              disabled={dayName === day}
              checked={copytimeTo.includes(dayName)}
              style={{ color: dayName === day ? '#7b7b7b' : undefined }}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleCheckboxChange(dayName)}
            />
          </div>
        </Menu.Item>
      ))}

      <Menu.Divider />

      <Menu.Item key='apply-button' disabled style={{ cursor: 'default' }}>
        <div style={{ margin: '16px 12px' }}>
          <Button
            className='detailsButton'
            size='large'
            onClick={(e) => {
              handleApplyAllChange();
            }}
            disabled={loading}
            style={{ width: '100%' }}
          >
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 16, color: '#f6f6f6' }}
                    spin
                  />
                }
              />
            ) : (
              'Apply'
            )}
          </Button>
        </div>
      </Menu.Item>
    </Menu>
  ) : component === 'more' ? (
    <Menu>
      <Menu.Item key='openAllDay'>
        <Radio
          checked={selectedOption === 'openAllDay'}
          onChange={() => handleRadioChange('openAllDay')}
        >
          <Typography className='timing'>Open all day</Typography>
        </Radio>
      </Menu.Item>
      <Menu.Item key='openPartDay'>
        <Radio
          checked={selectedOption === 'openPartDay'}
          onChange={() => handleRadioChange('openPartDay')}
        >
          <Typography className='timing'> Open part day</Typography>
        </Radio>
      </Menu.Item>
      <Menu.Item key='closedAllDay'>
        <Radio
          checked={selectedOption === 'closedAllDay'}
          onChange={() => handleRadioChange('closedAllDay')}
        >
          <Typography className='timing'>Closed all day</Typography>
        </Radio>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key='addTimeSlot'
        disabled={
          selectedOption === 'closedAllDay' || selectedOption === 'openAllDay'
        }
        style={{
          opacity:
            selectedOption === 'closedAllDay' || selectedOption === 'openAllDay'
              ? '0.5'
              : '1',
        }}
        onClick={() => timeSlotUpdate('addTimeSlot')}
      >
        <Typography className='timing'>Add time slot</Typography>
      </Menu.Item>
    </Menu>
  ) : null;
};
export default UpdateOperationTime;
